<div class="wrapper">
  <span class="question" [ngClass]="{'required': isRequired}">{{ question }}</span>
  <div class="btnContainer" [class.disabled]="isDisabled">
    <span [ngClass]="{
      'invalid-answer': displayError === true
    }" class="chipBtn clickable" *ngFor="let option of options" [class.active]="currentValue === option.value"
      (click)="onChangeValue(option.value)">{{ option.displayName }}</span>
  </div>
</div>